import { createSlice } from '@reduxjs/toolkit'
import { DataSet } from '../types.ts'
const initialState = {} as DataSet

export const storeSlice = createSlice({
  name: 'dataset',
  initialState,
  reducers: {
    pickDataset: (state, action) => {
      if (
        typeof action.payload == 'string' &&
        action.payload == "Don't track"
      ) {
        state.datasetName = undefined
        state.extraColumns = undefined
      } else if (
        typeof action.payload == 'object' &&
        'idColumn' in action.payload &&
        'datasetName' in action.payload &&
        'extraColumns' in action.payload &&
        'parentLayer' in action.payload
      ) {
        return { ...action.payload }
      }
    },
  },
})

export const { pickDataset } = storeSlice.actions

export default storeSlice.reducer
